import Model, { attr } from '@ember-data/model';

export default class AiOccasionContextModel extends Model {
  @attr('string') sentiment!: string;
  @attr('number') sentimentScore!: number;
  @attr('number') averageResponseTimeSeconds?: number;
  @attr('number') aiMessageCount!: number;
  @attr('string') summary?: string;
  @attr('boolean') autoReplyEnabled?: boolean | null;
  @attr('boolean') hasPendingDraft?: boolean | null;
  @attr('string') detectedLanguage?: string;
  @attr('string') languageOverride?: string;
  @attr('date') createdAt!: Date;
  @attr('date') updatedAt!: Date;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'ai-occasion-context': AiOccasionContextModel;
  }
}
